<!-- Feed Wizard Angular Template -->
<div class="wizard-overlay" (click)="onOverlayClick($event)">
  <div class="wizard-dialog" (click)="$event.stopPropagation()">
    <!-- Add Feed View -->
    @if (showAddView) {
      <div class="add-feed-view">
        <div class="feed-wizard-title ">Add Feed</div>
        <div class="feed-types-container">
          <div class="row">
            @for (feed of feedTypes; track feed) {
              <div class="col">
                <button type="button" class="btn btn-default feed-type-button" (click)="feedTypeClicked(feed)">
                  <img [src]="feed.icon" width="20" alt="" />
                  <br />
                  {{ feed.name }}
                </button>
              </div>
            }
          </div>
        </div>
        <div class="dialog-actions">
          <button type="button" class="btn btn-default" (click)="cancel()">Cancel</button>
        </div>
      </div>
    }

    <!-- Wizard View -->
    @if (!showAddView) {
      <div class="wizard-view">
        <div class="feed-wizard-title">Feed Wizard</div>
        <div class="row">
          <!-- Steps List -->
          <div class="col-lg-3 wizard-steps-list">
            @for (step of wizardSteps; track step; let i = $index) {
              <div class="wizard-step">
                <img [src]="i <= currentStep ? 'assets/img/wizard-step-complete.svg' : 'assets/img/wizard-step-incomplete.svg'" width="10" alt="" />
                {{ step }}
              </div>
            }
          </div>
          <!-- Step Content -->
          <div class="col-lg-9 wizard-step-content">
            <!-- Step 0: Feed Name -->
            @if (currentStep === 0) {
              <form [formGroup]="wizardForm">
                <label>Feed Name:</label>
                <input type="text" formControlName="feedName" class="form-control" required style="width: 90%" />
                @if (wizardForm.get('feedName')?.invalid && wizardForm.get('feedName')?.touched) {
                  <span class="error-message">
                    Feed name is required.
                  </span>
                }
              </form>
            }
            <!-- Plugin Steps -->
            @if (currentStep > 0 && currentStep < wizardSteps.length - 1) {
              <div>
                <!-- FMV Step -->
                @if (wizardSteps[currentStep].toLowerCase().includes('fmv')) {
                  <form>
                    <label>Video URI</label>
                    <input type="url" name="feedUrl" [(ngModel)]="fmvOptions.ipaddr" class="form-control" style="width: 50%" required />
                    @if (!fmvOptions.ipaddr) {
                      <span class="error-message">Feed URI is required.</span>
                    }
                    <label>Video Type</label>
                    <select name="videotype" [(ngModel)]="fmvOptions.videoType" class="form-control" style="width: 50%" required>
                      <option value="">Select Video Type</option>
                      @for (type of videoTypes; track type) {
                        <option [value]="type">{{ type }}</option>
                      }
                    </select>
                    @if (!fmvOptions.videoType) {
                      <span class="error-message">Video type is required.</span>
                    }
                  </form>
                }
                <!-- Other plugin steps -->
                @if (!wizardSteps[currentStep].toLowerCase().includes('fmv')) {
                  <div>
                    <div [innerHTML]="getCurrentStepTemplate()"></div>
                  </div>
                }
              </div>
            }
            <!-- Feed Options Step -->
            @if (currentStep === wizardSteps.length - 1) {
              <div class="feed-options" style="display: flex; align-items: center;">
                <!-- Bootstrap toggle switch -->
                <div class="form-check form-switch" style="margin-bottom: 0;">
                  <input class="form-check-input" type="checkbox" id="autostartSwitch" [(ngModel)]="autoStartStatus" name="autostart">
                </div>
                <div style="padding-left: 10px; display: inline-block; color: #000;">Autostart feed</div>
              </div>
            }
          </div>
        </div>
        <!-- Wizard Navigation Buttons -->
        <div class="wizard-actions" style="float: right; margin-top: 10px; margin-bottom: 10px; margin-right: 10px;">
          <button type="button" class="btn btn-default wizard-step-button" [disabled]="currentStep === 0" (click)="back()">Back</button>
          <button type="button" class="btn btn-default wizard-step-button" [disabled]="currentStep === wizardSteps.length - 1 || !canProceed()" (click)="next()">Next</button>
          <button type="button" class="btn btn-default wizard-step-button" [disabled]="currentStep < wizardSteps.length - 1 || !canFinish()" (click)="finish()">Finish</button>
          <button type="button" class="btn btn-default wizard-step-button" (click)="cancel()">Cancel</button>
        </div>
      </div>
    }
  </div>
</div>